module.exports = __webpack_public_path__ + "static/media/balance_img.b254348f.jpg";